var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.mounted)?_c('b-navbar',{staticClass:"action-bar cadfm-flexitem-fixed",attrs:{"toggleable":"md","type":_vm.s_skinVariant,"variant":_vm.s_skinVariant}},[_c('b-navbar-toggle',{attrs:{"target":_vm.id}}),_vm._v(" "),_c('b-collapse',{attrs:{"is-nav":"","id":_vm.id}},[_vm._t("default")],2)],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c33d8cd0","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/ActionBar.vue
// module id = null
// module chunks = 